var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"viewer",staticClass:"pdfjs-container",attrs:{"id":"viewer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }